(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const calendarEl = document.getElementById('calendar');
        if (!calendarEl) return;

        const eventsUrl = calendarEl.dataset.eventsUrl;
        const treemapUrl = calendarEl.dataset.treemapUrl || null;
        const initialDate = calendarEl.dataset.initialDate || null;
        const enableYearView = calendarEl.dataset.enableYearView === 'true';
        const highlightStrikeDays = calendarEl.dataset.highlightStrikeDays === 'true';

        let strikeDates = new Set();

        const config = {
            initialView: 'dayGridMonth',
            height: 950,
            eventContent: function (info) {
                return { html: info.event.title };
            },
            events: function (fetchInfo, successCallback, failureCallback) {
                fetch(eventsUrl)
                    .then(function (r) {
                        if (!r.ok) throw new Error('Network error');
                        return r.json();
                    })
                    .then(function (data) {
                        if (highlightStrikeDays) {
                            strikeDates = new Set(data.map(function (e) { return e.start; }));
                        }
                        successCallback(data);
                    })
                    .catch(failureCallback);
            }
        };

        if (initialDate) {
            config.initialDate = initialDate;
        }

        if (enableYearView) {
            config.headerToolbar = {
                left: 'prev,next',
                center: 'title',
                right: 'dayGridMonth,dayGridYear'
            };
        }

        if (highlightStrikeDays) {
            config.dayCellClassNames = function (arg) {
                const dateStr = arg.date.toISOString().split('T')[0];
                return strikeDates.has(dateStr) ? ['fc-day-has-strike'] : [];
            };
        }

        if (treemapUrl && window.StrikeTreemap) {
            config.datesSet = function (info) {
                window.StrikeTreemap.load(treemapUrl, info.view.calendar.currentData.viewTitle);
            };
        }

        const calendar = new FullCalendar.Calendar(calendarEl, config);
        calendar.render();
    });
})();
